import { createContext, useContext, useEffect } from 'react';
import type { Editor } from '@tiptap/react';

interface IEditorContext {
   editor: Editor;
}

const editorContextDefaults: IEditorContext = {
   // @ts-expect-error TS(2322) FIXME: Type 'null' is not assignable to type 'Editor'.
   editor: null,
};

export const EditorContext = createContext<IEditorContext>(editorContextDefaults);

export const useEditorContext = () => useContext(EditorContext);
